export default __webpack_public_path__ + "static/media/SAS Alert Tone 23.9297fa03.wav";